import React from 'react';
import styles from '../MarginSpace.module.scss';
import PanelContent from './PanelContent/PanelContent';
import { PanelTransparencyContextProvider } from './PanelTransparencyContext';
import PanelFooter from './PanelFooter/PanelFooter';
import { CreateProps } from '../../../types/utils/CreateProps';
import Element, { SupportedColor } from '../../Element/Element';
import Div from '../../Element/Div/Div';

export type PanelProps = CreateProps<
  {
    /** Panel background color */
    backgroundColor?: SupportedColor;
    /** Background color is transparent and vertical padding is removed */
    transparent?: boolean;
    tagName?: 'div' | 'article';
  },
  typeof Div
>;
// Alias for backwards compatibility
export type PanelAttributes = PanelProps;

const Panel: React.FunctionComponent<PanelProps> & {
  Content: typeof PanelContent;
  Footer: typeof PanelFooter;
} = ({
  children,
  transparent,
  backgroundColor = transparent ? 'transparent' : 'white',
  showOverflow = false,
  className,
  tagName = 'div',
  ...props
}) => {
  return (
    <PanelTransparencyContextProvider
      value={{ panelIsTransparent: transparent }}
    >
      <Element
        tagName={tagName}
        backgroundColor={backgroundColor}
        className={[styles.marginSpace_panel, className]}
        boxShadow={!transparent ? 'sm' : 'zero'}
        hideOverflow={!showOverflow}
        showOverflow={showOverflow}
        {...props}
      >
        {children}
      </Element>
    </PanelTransparencyContextProvider>
  );
};

Panel.Content = PanelContent;
Panel.Footer = PanelFooter;

export default Panel;
